export enum BookingChannel {
  PHONE = "phone",
  EMAIL = "email",
}

export const bookAppointment = () => {
  const contact = process.env.REACT_APP_PHONE_NUMBER;

  window.open(`https://wa.me/${contact}`, "_blank");
};
